import React from 'react'
import { FormField } from '../../../../Common/FormField'
import { handleKeyDown } from '../../Birthday/validate'
import { HandleYearChangeFunction, SetMonthFunction } from '../../Birthday/types'
import styles from './BasicInformation.module.css'

interface BirthdayFieldProps {
    year: string
    month: string
    onYearChange: HandleYearChangeFunction
    onMonthChange: SetMonthFunction
    hasInteractedBirthday: boolean
    birthdayValidateMessage: string
    yearLabel?: string
    monthLabel?: string
}

export const BirthdayField = ({
    year,
    month,
    onYearChange,
    onMonthChange,
    hasInteractedBirthday,
    birthdayValidateMessage,
    yearLabel = '年',
    monthLabel = '月',
}: BirthdayFieldProps) => (
    <>
        <div className={styles.birthdayField}>
            <FormField
                label={yearLabel}
                placeholder="2000"
                value={year}
                isInputType="tel"
                onChange={onYearChange}
                onKeyDown={handleKeyDown}
            />
            <FormField
                label={monthLabel}
                placeholder="01"
                value={month}
                isInputType="tel"
                onChange={onMonthChange}
                onKeyDown={handleKeyDown}
            />
        </div>
        {hasInteractedBirthday && birthdayValidateMessage && (
            <div className={styles.errorMessagesWrapper}>
                <p className={styles.errorMessages}>{birthdayValidateMessage}</p>
            </div>
        )}
    </>
)

